export default "__VITE_ASSET__7a1a5679__"